;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"6f0f8fd45c17ce097e3cff44aa69e9c4e2436926"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "16.2.4";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/production";globalThis["_sentryAssetPrefix"] = "https://assets-v2.i-scmp.com/production";globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";import * as Sentry from "@sentry/nextjs";

import { config } from "shared/data";
import { sentryConfig } from "shared/lib/sentry/config";
import { supportedBrowsers } from "shared/lib/sentry/supported-browsers";

const integrations = [
  Sentry.captureConsoleIntegration({ levels: ["error"] }),
  Sentry.contextLinesIntegration(),
  Sentry.extraErrorDataIntegration(),
  Sentry.extraErrorDataIntegration({ depth: 6 }),
  Sentry.graphqlClientIntegration({
    endpoints: [/\/content-delivery\/v2$/, /\/user-service\/v1$/],
  }),
  Sentry.httpClientIntegration(),
];

if (config.sentry.enableTracing) {
  integrations.push(
    Sentry.browserTracingIntegration({
      enableInp: false,
      enableLongAnimationFrame: false,
      enableReportPageLoaded: false,
    }),
  );
}

Sentry.init({
  ...sentryConfig,
  beforeSend: event => {
    // Filter out those browser is not in our supported list and user is not logged in
    if (
      (typeof navigator !== "undefined" && !supportedBrowsers.test(navigator.userAgent)) ||
      !event.user
    )
      return null;
    return event;
  },
  defaultIntegrations: false,
  integrations,
  replaysOnErrorSampleRate: config.sentry.enableTracing ? 1 : 0,
  replaysSessionSampleRate: config.sentry.enableTracing ? 0.01 : 0,
  sampleRate: 0.2,
  tracesSampleRate: config.sentry.enableTracing ? 0.01 : 0,
  transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
